window.$ = window.jQuery = require('jquery');
require('./jquery.dd.js');
require('./bootstrap.min.js');
// require('./jquery.validate.min.js');
require('./jquery.exit-modal.js');
require('./jquery.mixitup.min.js');
require('../../admin/assets/js/select2.full.min.js');
require('./owl.carousel.min.js');
require('../../admin/assets/js/jquery-ui.min.js');
require('./custom-owl-carousel-slider.js');
require('./bootsnav.js');
require('./main.js');
require('./custom.js');
require('./phone_number_validation.js');